var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.37488 6.97366C5.84531 8.83345 10.1801 12.1054 11.4542 13.1256C11.6252 13.2633 11.8087 13.3333 11.9991 13.3333C12.1892 13.3333 12.3723 13.2639 12.543 13.1269C13.8181 12.1057 18.1529 8.83345 20.6234 6.97366C20.7772 6.8581 20.8007 6.65496 20.6761 6.51368C20.3883 6.18719 19.9591 6 19.4991 6H4.49914C4.03919 6 3.60997 6.18719 3.32214 6.51371C3.19762 6.65496 3.22107 6.8581 3.37488 6.97366Z",
    fill: "#FF8000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7825 7.9803C20.6496 7.92529 20.4932 7.94448 20.3826 8.02849C17.6429 10.093 14.1464 12.7393 13.0463 13.6205C12.4288 14.1159 11.5719 14.1159 10.953 13.6198C9.78038 12.6807 5.85384 9.71343 3.61741 8.02845C3.50607 7.94445 3.34935 7.92592 3.21751 7.98027C3.08497 8.03499 3 8.15283 3 8.28271V16.6659C3 17.4013 3.67271 17.9993 4.50001 17.9993H19.5C20.3273 17.9993 21 17.4013 21 16.6659V8.28271C21 8.15283 20.915 8.03467 20.7825 7.9803Z",
    fill: "#FF8000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.740fc5cb5c703ebd2dd22ad5fdfe0d13.svg";
export { ForwardRef as ReactComponent };